import InjectIntercom from './InjectIntercom';

export default InjectIntercom;
